import React, { useState, useEffect } from "react";
// Components
import Preloader from "../../../components/Preloader/Preloader";
import MessageBox from "../../../components/MessageBox/MessageBox";
import { Redirect } from "react-router-dom"
import axios from "axios";
import { Clear, LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Chip from '@material-ui/core/Chip';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
});

const BranchPackageSalesSetPackage = (props) => {
	const classes = useStyles();
	const packagesales_home =  {
		pathname: "/sales"
	}
    const gobacktoHomepage = () => {
        props.history.push(packagesales_home);
    }
    const TransactionInformation = props.location.transactionInfo ? props.location.transactionInfo : '';

	//ApiData Component Content Variables
	const [location_dropdown, loadLocationDropdown] = useState([]);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [shipping_dropdown, loadShippingDropdown] = useState([]);
	const [team_dropdown, loadTeamDropdown] = useState([]);
	const [isLoaded, setisLoaded] = useState();
	const [isFranchise, setIsFranchise] = useState(false);
	const [nextPagePath, setnextPagePath] = useState("");
    const [selectedPackages, loadSelectedPackages] = useState({});
    const [isPackagesLoaded, setPackagesisLoaded] = useState(false);  

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF
	const headers = {
        'Content-Type': 'multipart/form-data',
    };
	//OnLoad Event/Data Fetching
	useEffect(() => {
		isLoggedIn();
		setisLoaded(false);
		get_warehouse();
		get_shipping();
		get_team();
		check_if_franchise();
		getselectedpackagesbranch();
	}, []);

	//Api Functions SOF
    const getselectedpackagesbranch = () => {
		const apiUrl = process.env.REACT_APP_API_URL+'getsetpackagesbranches';
		const form_data = {
			hqidno: branchIdNo,
			branchidno: TransactionInformation.branchidno,
            packno: TransactionInformation.packno,
            country: TransactionInformation.country,
            atype: TransactionInformation.atype,
			iscyop: TransactionInformation.jc_branchpurchase_iscyop
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadSelectedPackages(res.data.productPackageChosen);
            setPackagesisLoaded(true);
            setisLoaded(true);
		});
	};

	const get_warehouse = () => {
		//get data for warehouse/location dropdown
		const formData = new FormData();
		formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL+'warehouse';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadLocationDropdown(res.data.warehouse);
		});
	};

	const get_shipping = () => {
		//get data for shipping location dropdown
		const formData = new FormData();
		formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL+'shipping';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadShippingDropdown(res.data.shipping);
		});
	};

	const get_team = () => {
		//get data for shipping location dropdown
		const formData = new FormData();
		formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL+'team';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadTeamDropdown(res.data.team);
		});
	};

	const validate_required = () => {
		const apiUrl = process.env.REACT_APP_API_URL+'validate_required';
		const form_data = {
			required_fields: required_fields,
			reqfield_obj: prep_data
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			if(res.data.result.success == 1){
				validate_activationno();
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	
	const validate_activationno = () => {
		const apiUrl = process.env.REACT_APP_API_URL+'activationno_isvalid';
		const form_data = {
			idno: prep_data.activationcode,
			hqidno: branchIdNo
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			if(res.data.count > 0){
				if(isFranchise == true){
					validate_sponsor();
				}else{
					nextpage['packagechosen'] = selectedPackages;
					gotonextpage();
				}
			}else{
				setShowMsgBox(true);
				setMsg("Invalid Activation No.");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};

	const check_if_franchise = () => {
		if(TransactionInformation.isfranchise == "yes"){
            required_fields.push('sponsor_id');
            setIsFranchise(true);
        }else{
            setIsFranchise(false);
        }
	};

	const validate_sponsor = () => {
		const apiUrl = process.env.REACT_APP_API_URL+'check_sponsor';
		const form_data = {
			sponsor_id: prep_data.sponsor_id
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			if(res.data.success > 0){
				props.history.push(nextpage);
			}else{
				setShowMsgBox(true);
				setMsg("Invalid Sponsor ID");
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//Api Request Functions EOF

	const selectShippingProps = {
		options: shipping_dropdown,
		getOptionLabel: (option) => option.description,
	};

	const selectLocationProps = {
		options: location_dropdown,
		getOptionLabel: (option) => option.description

	};

    const selectTeamProps = {
		options: team_dropdown,
		getOptionLabel: (option) => option.description,
	};
	const [selectedDate, setSelectedDate] = React.useState(new Date());
	useEffect(() => {
		const newData = {...prep_data};
		newData['trandate']= formatDate(selectedDate);
		newData['shippingcharge']= 0;
		setData({ ...newData });
	}, []);
	//FormData SOF
	const [prep_data, setData] = useState({
        "soldto":TransactionInformation.soldto,
        "refcode":TransactionInformation.refcode,
        "transtype":TransactionInformation.transtype,
        "branchidno":TransactionInformation.branchidno,
        "jc_branchpurchase_iscyop":TransactionInformation.jc_branchpurchase_iscyop,
        "jc_branchpurchase":TransactionInformation.jc_branchpurchase,
        "atype":TransactionInformation.atype,
        "activationtype":TransactionInformation.activationtype,
		"country":TransactionInformation.country,
		"packno":TransactionInformation.packno,
		"isfranchise":TransactionInformation.isfranchise,
		"shippingcharge":TransactionInformation.shippingcharge,
    });
	const gotonextpage = () => {
		props.history.push(nextpage);
	}
	const onInputChange = (event) => {
		const newData = {...prep_data};
		newData[event.target.name]= event.target.value;
		setData({ ...newData });
	}
	const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}
	const required_fields = [
		"trandate",
		"soldto",
		"refcode",
		"activationcode",
		"warehouse",
		"shipping",
		"transtype",
		"primaryteam",
		"secondaryteam",
		"transtype",
        "branchidno"
	];
	//FormData EOF
	//FormData Validation SOF
	const nextpage =  {
		// pathname: "/package-sales-information",
		pathname: "/package-sales-payment",
		transactionInfo: prep_data, // your data array of objects
		pageInfo: {
            navid:"BranchPayment",
			navname: TransactionInformation.navname
		},
        isBranch:"set"
	}
	
	//FormData Validation EOF
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<NavLink to="/branch-package-purchase">
						<h2 className="header-title">Branch Package Purchase</h2>
					</NavLink>
					<Typography color="textPrimary">{TransactionInformation.navname}</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				{}
				{!isLoaded ? (
					<Preloader />
				) : (
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				    <Grid container spacing={3} justify="center">
                        <Grid item xs="6">
                            <Card>
                                <CardContent>
                                    <h4 className={classes.title}>Transaction Information</h4>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                    >
                                        <KeyboardDatePicker
                                            disableToolbar
                                            variant="inline"
                                            format="MM/dd/yyyy"
                                            name="trandate"
                                            label="Date"
                                            value={selectedDate}
                                            inputVariant="outlined"
                                            margin="normal"
											disabled="true"
											required="true"
											className={classes.date}
											onChange={onInputChange}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
											}}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <TextField
                                        name="soldto"
                                        label="Sold To"
                                        variant="outlined"
                                        type="text"
										margin="normal"
										required="true"
										className={classes.field}
                                        value={TransactionInformation.soldto}
                                        disabled="true"
                                    />
                                    <TextField
                                        name="refcode"
                                        label="Reference Code"
                                        variant="outlined"
                                        type="text"
										margin="normal"
										required="true"
										className={classes.field}
                                        value={TransactionInformation.refcode}
                                        disabled="true"
                                    />
                                    <Autocomplete
                                        {...selectLocationProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
										name="warehouse"
                                        renderInput={(params) => (
                                            <TextField
												{...params}
                                                margin="normal"
                                                label="Location"	
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												const newData = {...prep_data};
												newData['warehouse']= JSON.stringify(newValue.id, null, ' ');
												newData['warehouse_desc']= newValue.description;
												setData({ ...newData });
											}
										}}
                                    />
                                    <Autocomplete
                                        {...selectShippingProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
										name="shipping"
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Shipping"
                                                margin="normal"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												const newData = {...prep_data};
												newData['shipping']= JSON.stringify(newValue.id, null, ' ');
												newData['shipping_desc']= newValue.description;
												setData({ ...newData });
											}
										}}
                                    />
                                    <TextField
                                        name="activationcode"
                                        label="Activation Code"
                                        variant="outlined"
                                        type="text"
										margin="normal"
										required="true"
										className={classes.field}
										onChange={onInputChange}
                                    />
									{!isFranchise ? '':(
									<TextField
									name="sponsor_id"
									label="Sponsor ID"
									variant="outlined"
									type="text"
									margin="normal"
									required="true"
									className={classes.field}
									onChange={onInputChange}
									/>
									)}
                                    <TextField
                                        name="transtype"
                                        label="Transaction Type"
                                        variant="outlined"
                                        type="text"
										margin="normal"
										required="true"
										className={classes.field}
                                        value={TransactionInformation.transtype}
                                        disabled="true"
                                    />
                                    <TextField
                                        name="branchidno"
                                        label="Branch ID No."
                                        variant="outlined"
                                        type="text"
										margin="normal"
										required="true"
										className={classes.field}
										onChange={onInputChange}
                                        value={TransactionInformation.branchidno}
                                        disabled="true"
                                    />
                                    <TextField
                                        name="activationtype"
                                        label="Activation Type"
                                        variant="outlined"
                                        type="text"
										margin="normal"
										required="true"
										className={classes.field}
										onChange={onInputChange}
                                        value={TransactionInformation.activationtypelabel}
                                        disabled="true"
                                    />
									<Autocomplete
                                        {...selectTeamProps}
                                        name="primaryteam"
                                        autoComplete
										includeInputInList
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="normal"
                                                label="Primary Team"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												const newData = {...prep_data};
												newData['primaryteam']= JSON.stringify(newValue.id, null, ' ');
												newData['primaryteam_desc']= newValue.description;
												setData({ ...newData });
											}
										}}
                                    />
                                    <Autocomplete
                                        {...selectTeamProps}
                                        name="secondaryteam"
                                        autoComplete
										includeInputInList 
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="normal"
                                                label="Secondary Team"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												const newData = {...prep_data};
												newData['secondaryteam']= JSON.stringify(newValue.id, null, ' ');
												newData['secondaryteam_desc']= newValue.description;
												setData({ ...newData });
											}
										}}
                                    />
                                    <TextField
                                        name="shippingcharge"
                                        label="Shipping Charge"
                                        variant="outlined"
                                        margin="normal"
										type="text"
										disabled="true"
										className={classes.field}
										value={TransactionInformation.shippingcharge}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs="6">
                            <Card>
                                <CardContent>
									{TransactionInformation.jc_branchpurchase_iscyop == 1 ?
									<h4 className={classes.title}>Selected Products</h4>
									:
									<h4 className={classes.title}>Selected Packages</h4>
									}
									{isPackagesLoaded ? 
                                    selectedPackages.map((row, ind) => 
                                        <Chip label={selectedPackages[ind][0]['description']} style={{backgroundColor:"green",color:"white",margin:"10px",fontSize:"24px"}}/> 
										// console.log(ind)                                   
                                    )
                                    : null}
                                </CardContent> 
                            </Card>
                        </Grid>                        
                        <Grid item xs="12" className={classes.buttonContainer}>
							<Button 
								variant="contained" 
								color="primary"
								onClick={(e) => {
									validate_required();
								}}>
								Next
							</Button>
                        </Grid>
                    </Grid>
				</form>
				)}
			</div>
		</div>
	);
};

export default BranchPackageSalesSetPackage;
